/**
 * Landing (/welcome): the 23 s animated intro clip (anim/IntroClip) plays where the reference
 * shows its intro video; the logo star is drawn by a pencil tip, Scribble waves. "Let's draw" starts
 * onboarding; the link signs in an existing account.
 */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../../state/store';
import { useT } from '../../lib/i18n';
import { Scribble } from '../../components/characters';
import { Button, StarsLayer } from '../../components/ui';
import { Logo } from '../../components/Logo';
import { IntroClip } from '../../anim/IntroClip';
import { LanguageMenu } from '../../components/LanguagePicker';

export function Landing() {
  const t = useT();
  const nav = useNavigate();
  const logEvent = useApp((s) => s.logEvent);
  useEffect(() => logEvent('Landing Shown'), [logEvent]);

  return (
    <div className="full bg-night landing" data-testid="landing">
      <StarsLayer count={22} />
      <div className="landing-lang">
        <LanguageMenu />
      </div>
      <div className="landing-grid">
        <div className="landing-copy col">
          <Logo size={64} />
          <h1 className="landing-title">{t('onb.landing.title')}</h1>
          <p className="muted landing-sub">{t('onb.landing.sub')}</p>
          <div className="col landing-ctas">
            <Button onClick={() => nav('/onboarding')} data-testid="landing-start">
              {t('onb.landing.start')}
            </Button>
            <Button variant="ghost" small onClick={() => nav('/signin')} data-testid="landing-signin">
              {t('onb.landing.signin')}
            </Button>
          </div>
        </div>
        <div className="landing-art">
          <IntroClip />
          <Scribble mood="wave" size={120} className="landing-scribble" />
        </div>
      </div>
    </div>
  );
}
